export const showSearchForm = () => {
    
};

export const showNavBar = () => {
    $('#nav-open-close').click(function() {

      if( $('#nav-open-close').hasClass('open') ){
        //cerrar menu
        $('#header').removeClass('menu-opened');
        $('.header__desplegable').removeClass('appear');
        $('#nav-open-close').removeClass('open');
      } else {
       	//abrir
        $('#header').addClass('menu-opened');
        $('#nav-open-close').addClass('open');
        $('.header__desplegable').addClass('appear');

      }
    });

    $('#negroID').click(function() {
        $('#header').removeClass('menu-opened');
        $('.header__desplegable').removeClass('appear');
        $('#nav-open-close').removeClass('open');
    });
};

export const removeLinksHref = () => {
    // remove link from menu items that have children
    //$(".header__nav-mobile li.menu-item-has-children > a").attr("href", "#");
    // substitute a for span
    $(".menu li.menu-item-has-children > a").each(function() {
        var $this = $(this);
        $this.replaceWith('<span class="menu-link">' + $this.text() + '</span>');
    });
}

export const makeMobileNav = () => {

    /* ACCORDION EFFECT MAIN MENU */
     // prevent page from jumping to top from  # href link
    $('.header__nav-mobile li.menu-item-has-children > a').click(function(e) {
        e.preventDefault();
    });
    // remove link from menu items that have children
    $(".header__nav-mobile li.menu-item-has-children > a").attr("href", "#");
    //  function to open / close menu items
    $(".header__nav-mobile a").click(function() {
        var link = $(this);
        var closest_ul = link.closest("ul");
        var parallel_active_links = closest_ul.find(".active")
        var closest_li = link.closest("li");
        var link_status = closest_li.hasClass("active");
        var count = 0;

        closest_ul.find("ul").slideUp(function() {
            if (++count == closest_ul.find("ul").length)
                    parallel_active_links.removeClass("active");
        });

        if (!link_status) {
            closest_li.children("ul").slideDown();
            closest_li.addClass("active");
        }
    });

}